import { render, staticRenderFns } from "./ModalDescartarRepasse.vue?vue&type=template&id=797b5b1c"
import script from "./ModalDescartarRepasse.vue?vue&type=script&lang=ts"
export * from "./ModalDescartarRepasse.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports